/* RE3AYA MOBILE BOTTOM NAV V3 */

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".r3-bottom-nav")) return;

  const nav = document.createElement("div");
  nav.className = "r3-bottom-nav";

  nav.innerHTML = `
    <button class="r3-bottom-item" data-action="shop" aria-label="Shop">
      <span class="r3-bottom-icon"><svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16"/></svg></span>
      <span class="r3-bottom-label">Shop</span>
    </button>

   <a class="r3-bottom-item" href="/collections/pharmacy" aria-label="Meds">
  <span class="r3-bottom-icon r3-meds-icon">
    <svg viewBox="0 0 24 24">
      <rect x="5" y="8" width="9" height="11" rx="2"></rect>
      <path d="M7 5h5"></path>
      <path d="M8 5v3"></path>
      <path d="M11 5v3"></path>
      <path d="M15.5 10.5a2.5 2.5 0 0 1 3.5 0l1 1a2.5 2.5 0 0 1 0 3.5l-1 1a2.5 2.5 0 0 1-3.5 0l-1-1a2.5 2.5 0 0 1 0-3.5z"></path>
      <path d="M15.5 10.5l4.5 4.5"></path>
    </svg>
  </span>
  <span class="r3-bottom-label">Meds</span>
</a>

    <a class="r3-bottom-item r3-cart-item" href="/cart" aria-label="Cart">
      <span class="r3-bottom-icon"><svg viewBox="0 0 24 24"><path d="M6 7h15l-2 9H8L6 7z"/><path d="M6 7L5 4H3"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg></span>
      <span class="r3-bottom-count"></span>
      <span class="r3-bottom-label">Cart</span>
    </a>

    <a class="r3-bottom-item" href="/account" aria-label="Account">
      <span class="r3-bottom-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg></span>
      <span class="r3-bottom-label">Account</span>
    </a>

    <button class="r3-bottom-item r3-search-item" data-action="search" aria-label="Search">
      <span class="r3-bottom-icon"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg></span>
      <span class="r3-bottom-label">Search</span>
    </button>
  `;

  document.body.appendChild(nav);
    /* Active state */
  const path = window.location.pathname;
  let activeItem = null;

  if (path === "/cart") {
    activeItem = nav.querySelector('a[href="/cart"]');
  } else if (path.includes("/collections/pharmacy")) {
    activeItem = nav.querySelector('a[href="/collections/pharmacy"]');
  } else if (path.includes("/account")) {
    activeItem = nav.querySelector('a[href="/account"]');
  } else if (path.includes("/search")) {
    activeItem = nav.querySelector('[data-action="search"]');
  } else {
    activeItem = nav.querySelector('[data-action="shop"]');
  }

  if (activeItem) {
    activeItem.classList.add("r3-active");
  }

  const countEl = nav.querySelector(".r3-bottom-count");

  function updateCartCount() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const count = cart.item_count || 0;
        countEl.textContent = count;
        countEl.style.display = count > 0 ? "block" : "none";
      })
      .catch(() => {});
  }

  updateCartCount();
  setInterval(updateCartCount, 2500);

  nav.querySelector('[data-action="shop"]').addEventListener("click", function () {
    const menuBtn = document.querySelector("header-drawer summary");
    if (menuBtn) menuBtn.click();
  });

  nav.querySelector('[data-action="search"]').addEventListener("click", function (e) {
    e.preventDefault();

    const searchDetails =
      document.querySelector("details-modal.header__search details") ||
      document.querySelector(".header__search details");

    if (searchDetails) {
      searchDetails.setAttribute("open", "open");
      setTimeout(function () {
        const input = document.querySelector(".search__input, input[type='search']");
        if (input) input.focus();
      }, 150);
    } else {
      window.location.href = "/search";
    }
  });
});
